// extracted by mini-css-extract-plugin
export var CloseButtonCircle = "M_ch";
export var CloseButtonIcon = "M_cj";
export var CloseLabel = "M_ck";